import gql from "graphql-tag";
const getCashManagement = gql(`
query MyQuery($fundid: String, $startdate: date, $enddate: date) {
    CashManagement_Transactions(order_by: {Id: asc}, where: { FundId: {_eq: $fundid }, WireDate: {_gte: $startdate, _lte: $enddate}}) {
    Id
    BalMMA
    BalSplit
    CoMMA
    CoSplit
    Deal
    FRBBalCkg
    FRBCoInvestCKG
    FXRate
    FXRateDate
    Fund
    FundId
    Notes
    TiesToBank
    TrIIIMMA
    TrIIISplit
    TrIIMMA
    TrIISplit
    TrIVMMA
    TrIVSplit
    TrVMMA
    TrvSplit
    WireDate
    }
  }`)
export default getCashManagement;
